// src/components/roles/Table/RolesTableRow.jsx
import React from 'react';
import { TableRow, TableCell, IconButton, Chip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PersonIcon from '@mui/icons-material/Person';

const RolesTableRow = ({
    role,
    index,
    isArabic,
    isDark,
    page,
    perPage,
    order,
    totalItems,
    onMenuOpen,
    menuDisabled = false,
    isUserOwnRole = false,
}) => {
    const serial =
        order === 'asc'
            ? (page - 1) * perPage + index + 1
            : (page - 1) * perPage + (totalItems - index);

    const isOdd = index % 2 === 0;

    return (
        <TableRow
            key={role?.id}
            hover
            sx={{
                cursor: 'pointer',
                '&:last-child td, &:last-child th': { border: 0 },
                backgroundColor: isDark
                    ? isOdd
                        ? '#020617'
                        : '#050816'
                    : isOdd
                        ? '#F2F7FF'
                        : '#FFFFFF',
                '&:hover': {
                    backgroundColor: isDark ? '#111827' : '#E3F2FD',
                },
                transition: 'background-color 0.15s ease',
            }}
        >
            <TableCell align="center">{serial}</TableCell>

            <TableCell align="center">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    {role?.name}
                    {isUserOwnRole && (
                        <Chip
                            icon={<PersonIcon />}
                            label={isArabic ? 'دورك' : 'Your Role'}
                            size="small"
                            color="primary"
                            sx={{
                                fontSize: '0.7rem',
                                height: '22px',
                                fontWeight: 500,
                            }}
                        />
                    )}
                </div>
            </TableCell>

            <TableCell align="center">
                <IconButton
                    size="small"
                    // disabled={menuDisabled}
                    onClick={(e) => {
                        e.stopPropagation();
                        onMenuOpen(e, role);
                    }}
                    sx={{
                        color: isDark ? '#E5E7EB' : '#1F2937',
                    }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default RolesTableRow;
